// extracted by mini-css-extract-plugin
export default {"switch":"ThemeSwitch_switch__F2jzi","icon":"ThemeSwitch_icon__Px9JD","thumb":"ThemeSwitch_thumb__2wNGJ"};